import React, { createContext, useState, useContext, useCallback } from "react";
import { IntlProvider } from "react-intl";
import { ErrorModal } from "../components/ErrorModal/ErrorModal";

import messagesEn from "../common/translation/en.json";
import messagesAm from "../common/translation/am.json";
import { Language, LANGUAGE_KEY } from "../constants/sampleModels";
export const LocaleContext = createContext({
  handleSetLocale: (locale) => {},
  isErrrModalShow: null,
  setErrorModalShow: () => {},
});
const LocaleContextProvider = ({ children }) => {
  const [isErrrModalShow, setErrorModalShow] = useState(null);
  const [locale, setLocale] = useState(
    localStorage.getItem(LANGUAGE_KEY) ?? Language.En
  );
  const messages = locale === Language.En ? messagesEn : messagesAm;
  const handleSetLocale = useCallback((locale) => {
    setLocale(locale);
    localStorage.setItem(LANGUAGE_KEY, locale);
  }, []);
  const contextValue = {
    handleSetLocale,
    isErrrModalShow,
    setErrorModalShow,
  };
  return (
    <IntlProvider locale={locale} messages={messages}>
      <LocaleContext.Provider value={contextValue}>
        {isErrrModalShow && (
          <ErrorModal
            setErrorModalShow={setErrorModalShow}
            isErrrModalShow={isErrrModalShow}
          />
        )}
        {children}
      </LocaleContext.Provider>
    </IntlProvider>
  );
};

export function useLocale() {
  return useContext(LocaleContext);
}

export default LocaleContextProvider;
